/**
 * System Maintenance UI tokens — aligned with Import Reports (reportTheme).
 */
export {
    reportPage as maintenancePage,
    reportContainer as maintenanceContainer,
    reportShell as maintenanceShell,
    reportShellTopBar as maintenanceShellTopBar,
    reportCard as maintenanceCard,
    reportCardPadding as maintenanceCardPadding,
    reportSectionTitle as maintenanceSectionTitle,
    reportMutedText as maintenanceMutedText,
    reportHeading as maintenanceHeading,
    reportInput as maintenanceInput,
    reportLabel as maintenanceLabel,
    reportBtnPrimary as maintenanceBtnPrimary,
    reportBtnSecondary as maintenanceBtnSecondary,
    reportHeaderIconBtn as maintenanceHeaderIconBtn,
    reportHeaderExportBtn as maintenanceHeaderExportBtn,
    reportBtnIconCompact as maintenanceBtnIconCompact,
    reportTableHeader as maintenanceTableHeader,
    reportTableTh as maintenanceTableTh,
    reportTableTd as maintenanceTableTd,
    reportTableRow as maintenanceTableRow,
    reportPaginationWrap as maintenancePaginationWrap,
} from "@/components/reports/layout/reportTheme";

/** Field control base — use with cn() and width utilities (avoids w-full conflicts). */
export const maintenanceFieldBase =
    "h-9 px-3 rounded-lg text-[13px] transition-colors " +
    "bg-gray-50 border border-gray-200 text-gray-800 placeholder-gray-400 " +
    "focus:outline-none focus:ring-2 focus:ring-blue-500/25 focus:border-blue-500 " +
    "dark:bg-gray-800/80 dark:border-gray-700 dark:text-white dark:placeholder-gray-500";

export const maintenanceFieldSelect = `${maintenanceFieldBase} w-full appearance-none cursor-pointer`;
export const maintenanceFieldInput = `${maintenanceFieldBase} w-full min-w-0`;

/** Shared DataTable props — matches ReportDataGrid / Import Reports grid. */
export const maintenanceTableProps = {
    trClass:
        "border-b border-gray-100 dark:border-gray-800/80 hover:bg-gray-50/80 dark:hover:bg-gray-800/40 transition-colors",
    thClass:
        "px-4 py-2.5 text-left text-[11px] font-semibold text-gray-600 dark:text-gray-300 uppercase tracking-wider",
    tdClass: "px-4 py-2.5 text-[13px] text-gray-800 dark:text-gray-200 align-middle",
    htrClass: "bg-gray-50/90 dark:bg-gray-800/80 border-b border-gray-200 dark:border-gray-800",
    boxClass:
        "border-0 rounded-none shadow-none bg-transparent dark:bg-transparent overflow-hidden",
};

export const accentIconWrap = {
    blue: "shrink-0 w-10 h-10 sm:w-11 sm:h-11 rounded-xl bg-blue-50 dark:bg-blue-900/40 ring-1 ring-blue-100 dark:ring-blue-800 flex items-center justify-center",
    purple: "shrink-0 w-10 h-10 sm:w-11 sm:h-11 rounded-xl bg-purple-50 dark:bg-purple-900/40 ring-1 ring-purple-100 dark:ring-purple-800 flex items-center justify-center",
    cyan: "shrink-0 w-10 h-10 sm:w-11 sm:h-11 rounded-xl bg-cyan-50 dark:bg-cyan-900/40 ring-1 ring-cyan-100 dark:ring-cyan-800 flex items-center justify-center",
    emerald:
        "shrink-0 w-10 h-10 sm:w-11 sm:h-11 rounded-xl bg-emerald-50 dark:bg-emerald-900/40 ring-1 ring-emerald-100 dark:ring-emerald-800 flex items-center justify-center",
};

export const accentIconText = {
    blue: "text-blue-600 dark:text-blue-400",
    purple: "text-purple-600 dark:text-purple-400",
    cyan: "text-cyan-600 dark:text-cyan-400",
    emerald: "text-emerald-600 dark:text-emerald-400",
};
